module.exports = __webpack_public_path__ + "img/thumbnail-product-world.42c0455f.webp";